import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdListAlt } from 'react-icons/md';
import { generatePreparation } from 'interfaces/orderPreparation';

interface GeneratePreparationButtonProps {
    orderId: string;
    orderStatus: string;
    isReady?: boolean;
}

const GeneratePreparationButton = ({ orderId, orderStatus, isReady }: GeneratePreparationButtonProps) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleGenerate = async () => {
        if (orderStatus !== 'confirmed' && orderStatus !== 'pending') {
            console.error('La commande doit être confirmée pour générer une préparation');
            return;
        }

        setLoading(true);
        const res = await generatePreparation(orderId);
        
        if (res) {
            console.log('Préparation générée avec succès');
            navigate(`/preparations/${res._id}`);
        } else {
            setLoading(false);
        }
    };

    return (
        <button
            className="hidden sm:flex linear cursor-pointer items-center gap-2 justify-center rounded-xl border border-[#01499b] px-2 py-1 text-xs text-[#01499b] transition duration-200 hover:bg-brand-600/5 active:bg-brand-100 disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={handleGenerate}
            disabled={loading}
        >
            <MdListAlt size={13} />
            {loading ? 'Génération...' : 'Générer préparation'}
        </button>
    );
};

export default GeneratePreparationButton;
